export default "__VITE_PUBLIC_ASSET__3707b236__"